import { CSRF_TOKEN_HEADER } from "../constants/common";

export default (csrfToken) => {
  return csrfToken ? { [CSRF_TOKEN_HEADER]: csrfToken } : {};
};
